import React from 'react';
import { Shimmer, ShimmerElementType } from '@fluentui/react';

const rowElement = [{ type: ShimmerElementType.line, height: 50 }];
const buttonElement = [
  { type: ShimmerElementType.line, height: 32, width: '25%' },
  { type: ShimmerElementType.gap, width: '60%' },
  { type: ShimmerElementType.line, height: 12, width: '15%' },
];

export function ShimmerCard() {
  return (
    <div className="shimmer-container">
      <Shimmer shimmerElements={rowElement} style={{ marginBottom: 5 }} />
      <Shimmer shimmerElements={rowElement} style={{ marginBottom: 5 }} />
      <Shimmer shimmerElements={rowElement} style={{ marginBottom: 5 }} />
      <Shimmer shimmerElements={rowElement} style={{ marginBottom: 5 }} />
      <Shimmer shimmerElements={rowElement} style={{ marginBottom: 5 }} />
      <Shimmer shimmerElements={buttonElement} style={{ marginBottom: 5, marginTop: 15 }} />
    </div >
  );
}
